import { useMemo } from 'react'

import { useAllStreams } from './useAllStreams'

export type OperationSeason = {
  cropKey: string
  cropLabel: string
  year: number
  label: string
}

export const useOperationSeasons = (): OperationSeason[] => {
  const streams = useAllStreams()

  return useMemo(() => {
    const byKey = (streams.data ?? []).reduce((map, stream) => {
      const key = `${stream.season}|${stream.cropKey}`
      if (!map.has(key)) {
        map.set(key, {
          cropKey: stream.cropKey,
          cropLabel: stream.cropLabel,
          year: stream.season,
          label: `${stream.season} | ${stream.cropLabel}`
        })
      }
      return map
    }, new Map<string, OperationSeason>())

    return Array.from(byKey.values()).sort(
      (a, b) => b.year - a.year || a.cropKey.localeCompare(b.cropKey)
    )
  }, [streams.data])
}
